import { Box } from "@mui/material"

const AppContainer = ({ children }) => {
  return (
    <Box sx={{
      display: 'flex',
      justifyContent: 'center'
    }}>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          position: 'relative',
          bgcolor: 'background.default'
          // maxWidth: '1440px',
        }}
      >
        {children}
      </Box>
    </Box>
  )
}

export default AppContainer